type FilterOptions = "cover" | "alcohol";

export const useFilterOptions = (filterOptions: string[]) => {
  const hasOption = (feature: FilterOptions): boolean =>
    filterOptions?.includes(feature);

  return { hasOption };
};
